import {
  isValidShrInterval,
  ShrInterval,
} from '../../wave/types/interval.type';
import { Definition } from '../types/diagnostic';

export const SEVERE_BRADYCARDIA_HR_THRESHOLD = 35;
export const MODERATE_BRADYCARDIA_HR_THRESHOLD = 40;
export const SEVERE_TACHYCARDIA_HR_THRESHOLD = 190;
export const MODERATE_TACHYCARDIA_HR_THRESHOLD = 140;
export const ASYSTOLE_RR_THRESHOLD = 5000;
export const PAUSE_RR_THRESHOLD = 2000;
export const VENTRICULAR_TACHYCARDIA_HR_THRESHOLD = 100;

export const PRIMARY_LABELS_CONFIG: Record<string, Definition> = {
  CL_rh_5: {
    category: 'Rythme',
    code: 'CL_rh_5',
    name: 'Pause (≥ 2000 ms)',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_6: {
    category: 'Rythme',
    code: 'CL_rh_6',
    name: 'Asystole (≥ 5000 ms)',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_7: {
    category: 'Rythme',
    code: 'CL_rh_7',
    name: 'Moderate bradycardia',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_8: {
    category: 'Rythme',
    code: 'CL_rh_8',
    name: 'Severe bradycardia',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_9: {
    category: 'Rythme',
    code: 'CL_rh_9',
    name: 'Moderate tachycardia',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_10: {
    category: 'Rythme',
    code: 'CL_rh_10',
    name: 'Severe tachycardia',
    likelihood: null,
    frequency: null,
    temporality: null,
    localization: null,
  },
  CL_rh_v_17: {
    category: 'Rythme',
    code: 'CL_rh_v_17',
    name: 'VT - Ventricular tachycardia',
    likelihood: ['possible', 'probable', 'confirmed'],
    frequency: null,
    temporality: ['intermittent'],
    localization: null,
  },
  CL_rh_v_18: {
    category: 'Rythme',
    code: 'CL_rh_v_18',
    name: 'VR - Ventricular rhythm',
    likelihood: ['possible', 'probable', 'confirmed'],
    frequency: null,
    temporality: ['intermittent'],
    localization: null,
  },
};

export const isVentricularRhythm = (shrArray: ShrInterval[]) =>
  shrArray.some((shrObj, i) => {
    if (i < 3) {
      return false;
    }
    const fourConsecutiveShr = [
      shrObj,
      shrArray[i - 1],
      shrArray[i - 2],
      shrArray[i - 3],
    ];
    return (
      fourConsecutiveShr.every((shrInterval) => {
        if (isValidShrInterval(shrInterval)) {
          return shrInterval.shr < VENTRICULAR_TACHYCARDIA_HR_THRESHOLD;
        }
        return true;
      }) && fourConsecutiveShr.every(({ pvc }) => pvc)
    );
  });

export const isVentricularTachycardia = (shrArray: ShrInterval[]) =>
  shrArray.some((shrObj, i) => {
    if (i < 3) {
      return false;
    }
    const fourConsecutiveShr = [
      shrObj,
      shrArray[i - 1],
      shrArray[i - 2],
      shrArray[i - 3],
    ];
    return (
      fourConsecutiveShr.some((shrInterval) => {
        if (isValidShrInterval(shrInterval)) {
          return shrInterval.shr >= VENTRICULAR_TACHYCARDIA_HR_THRESHOLD;
        }
        return false;
      }) && fourConsecutiveShr.every(({ pvc }) => pvc)
    );
  });
